module.exports = __webpack_public_path__ + "img/118.d1642339.d1642339.png";